window.addEventListener('scroll', function () {
  var element = document.getElementById('sticky');
  if (element) {
    var inner = document.getElementById('sticky__inner');
    var elementPosition = element.getBoundingClientRect().top + window.scrollY;
    var offset = 120; // 固定する距離

    const Check = () => {
      let width = window.innerWidth;
      if (width < 1024) {
        return 'sp';
      } else {
        return 'pc';
      }
    }

    if (Check() == 'pc') {
      if (window.scrollY > elementPosition - offset) {
        inner.classList.add('fixed');
      } else {
        inner.classList.remove('fixed');
      }
    }
  }

});